import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import {Link } from 'react-router-dom'
//redux stuff
import {loginUser} from '../redux/actions/userActions'
import {connect } from 'react-redux'
const styles = {
  form: {
    textAlign: "center",
    backgroundColor:'#00b2ff9e',
    height:'100vh',
   // backgroundImage: 'url(park.jpg)'

  },
  pageTitle: {
    margin: "20px auto 20px auto",
  },
  textField: {
    margin: "10px auto 10px auto",
  },
  button: {
    margin: 20,
    backgroundColor:'#0b3040 !important'
  },
  customError:{
      color:"red",
      fontSize:'0.8rem'
  }
};

class login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      loading: false,
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.UI.errors){

      this.setState({errors: nextProps.UI.errors});
    }
    
  }

  handleSubmit = (event) => {
    event.preventDefault();

    //localStorage.setItem('FBidToken',`Bearer ${res.data.token}`);
    const userData = {
      email: this.state.email,
      password: this.state.password,
    };
    this.props.loginUser(userData,this.props.history)
  };
  
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const { classes, UI:{loading}} = this.props;
    const {errors} = this.state;

    return (
      <div >
        
        
      <Grid container className={classes.form}>
      
        <Grid item sm />
        
        <Grid item sm>
  
          <form noValidate onSubmit={this.handleSubmit}>
            <img alt="" style={{height:'50vh',margin:'0 auto'}} src='upinverse.png'/>
            <Typography style={{color:'#0b3040'}}variant="h4" className="">
            Login
          </Typography>
            <TextField
            style={{backgroundColor:"white",width:"80%"}}
              id="email"
              name="email"
              type="email"
              label="Email"
              className={classes.textField}
              helperText={errors.email}
              error={errors.email ? true : false}
              value={this.state.email}
              onChange={this.handleChange}
              fullWidth
            />
           
            <TextField
                style={{backgroundColor:"white",width:"80%"}}
              id="password"
              name="password"
              type="password"
              label="password"
              className={classes.textField}
              helperText={errors.password}
              error={errors.password ? true : false}
              value={this.state.password}
              onChange={this.handleChange}
              fullWidth
            />
            {errors.general && (
                <Typography variant='body2' className={classes.customError}>
                    {errors.general}
                </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Login
            </Button>
            <br/>
            <small style={{color:'white'}}>
                sign up here! <Link to="/signup">Click</Link>
            </small>

          </form>
        </Grid>
        <Grid item sm />
      </Grid>
      </div>
    );
  }
}

login.propTypes = {
  classes: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user:state.user,
  UI:state.UI
});

const mapActionsToProps = {
  loginUser
}


export default connect(mapStateToProps,mapActionsToProps)(withStyles(styles)(login));

